import axios from 'axios'
import { Message } from 'iview'
axios.interceptors.request.use(
  config => {
    if (config.url.indexOf('/whileflow/v1/user/userlogin') === -1) {
      config.headers.token = sessionStorage.getItem('token')
    }
    return config
  },
  err => Promise.reject(err)
)
axios.interceptors.response.use(
  response => response,
  err => {
    if (err.response && err.response.data) {
      switch (err.response.data.code) {
        case 20000:
          Message.error('用户名或密码错误')
          break
        case 20001:
          Message.error('原密码错误')
          break
        case 20002:
          Message.error('token不正确')
          break
      }
    }
    return Promise.reject(err)
  }
)

export default axios


// WEBPACK FOOTER //
// ./src/axios/index.js